import { useEffect, useRef } from "react";
import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import SFTextEditor from "../../textEditor";
import { useTranslation } from "react-i18next";
import getStyled from "../../../hooks/getStyled";
import InputErrorLabel from "../../inputErrorLabel";

const { styled } = getStyled();

const ErrorWrapper = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginLeft: theme.spacing(0.5),
}));

const TextEditorRenderer = (props) => {
  const { t } = useTranslation();
  const editorRef = useRef();

  useEffect(() => {
    if (!props.required) return;
  }, [props.data]);

  return (
    <>
      <SFTextEditor
        hasError={props.errors?.length > 1}
        ref={editorRef}
        value={props.data}
        onChange={(val) => {
          props.handleChange(props.path, val);
        }}
        label={t(props.uischema.i18nKey)}
        readOnly={props.uischema?.options?.readonly}
        required={props.required}
        {...(props.uischema?.options?.toolbar && {
          toolbar: props.uischema.options.toolbar,
        })}
        maxLength={props.uischema?.options?.maxLength}
        customIcon={props.uischema?.options?.customIcon}
        isCopilotField={props.uischema?.options?.isCopilotField}
        preventSyncEffect={props.uischema?.options?.preventSyncEffect ?? true}
      />
      {props.errors.length > 1 && (
        <ErrorWrapper>
          <InputErrorLabel label={props.errors} />
        </ErrorWrapper>
      )}
    </>
  );
};

export const TextEditorTester = rankWith(
  104,
  schemaMatches((schema) => schema.textEditor === true)
);

export default withJsonFormsControlProps(TextEditorRenderer);
